import { Observable } from 'rxjs/Rx'
import * as authenticationDuck from 'store/ducks/authentication'
import { combineEpics } from 'redux-observable'
import { deliveriesEmptyReturns } from '../services/delivery'
import { DELIVERY_MODIFY_SUCCESS } from './operations'

export const EMPTY_RETURNS_REQUEST = 'deliveryEmptyReturns/EMPTY_RETURNS_REQUEST'
export const EMPTY_RETURNS_SUCCESS = 'deliveryEmptyReturns/EMPTY_RETURNS_SUCCESS'
export const EMPTY_RETURNS_FAILURE = 'deliveryEmptyReturns/EMPTY_RETURNS_FAILURE'

const INITIAL_STATE = {
  rides: [],
  isLoading: false,
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case EMPTY_RETURNS_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case EMPTY_RETURNS_SUCCESS:
      return {
        ...state,
        rides: action.payload,
        isLoading: false,
      }
    case EMPTY_RETURNS_FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    default:
      return state
  }
}

export const emptyReturnsRequest = (id, companyId = null) => ({
  type: EMPTY_RETURNS_REQUEST,
  id,
  companyId,
})

export const emptyReturnsSuccess = (payload) => ({
  type: EMPTY_RETURNS_SUCCESS,
  payload,
})

export const emptyReturnsFailure = (errors) => ({
  type: EMPTY_RETURNS_FAILURE,
  errors,
})

export const epic = combineEpics(deliveriesEmptyReturnsRequestEpic, deliveryModifySuccessEpic)

export function deliveriesEmptyReturnsRequestEpic(action$) {
  return action$.ofType(EMPTY_RETURNS_REQUEST).mergeMap((action) =>
    Observable.ajax(deliveriesEmptyReturns({ params: { id: action.id, companyId: action.companyId } }))
      .mergeMap((res) => Observable.of(emptyReturnsSuccess(res.response), ...(!res.response.length ? [] : [])))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(emptyReturnsFailure())
      }),
  )
}

export function deliveryModifySuccessEpic(action$) {
  return action$.ofType(DELIVERY_MODIFY_SUCCESS).mergeMap((action) => {
    const modifiedDelivery = action.payload
    if (modifiedDelivery.companyCourierStart || modifiedDelivery.hasOwnProperty('emptyReturnRide')) {
      return Observable.of(emptyReturnsRequest(modifiedDelivery.id))
    }
    return Observable.empty()
  })
}
